import {
  Create,
  CreateButton,
  Edit,
  EditButton,
  List,
  ShowButton,
  useDrawerForm,
  useForm,
  useTable,
} from '@refinedev/antd';
import {
  IExperienceAction,
  IExperienceActionFilterVariables,
} from '../../../interfaces/experience';
import { Button, Drawer, Form, Input, Space, Table } from 'antd';
import { HttpError } from '@refinedev/core';

export const ExperienceActionList = () => {
  // table
  const { tableProps, searchFormProps } = useTable<
    IExperienceAction,
    HttpError,
    IExperienceActionFilterVariables
  >({
    sorters: {
      initial: [{ field: 'createdAt', order: 'desc' }],
    },
    meta: {
      fields: ['id', 'name', 'title', 'description', 'advice'],
    },
    onSearch: (params) => {
      const { id, name, title } = params;
      return [
        {
          field: 'id',
          operator: 'eq',
          value: id,
        },
        {
          field: 'name',
          operator: 'contains',
          value: name,
        },
        {
          field: 'title',
          operator: 'contains',
          value: title,
        },
      ];
    },
  });

  // create
  const {
    formProps: createFormProps,
    drawerProps: createDrawerProps,
    show: createDrawerShow,
    saveButtonProps: createSaveButtonProps,
    deleteButtonProps: createDeleteButtonProps,
    id,
    formLoading: editFormLoading,
  } = useDrawerForm<IExperienceAction>({
    action: 'create',
    syncWithLocation: true,
    meta: {
      fields: [{ experienceAction: ['id'] }],
    },
  });

  // edit
  const {
    formProps: editFormProps,
    drawerProps: editDrawerProps,
    show: editDrawerShow,
    saveButtonProps: editSaveButtonProps,
  } = useDrawerForm<IExperienceAction>({
    action: 'edit',
    syncWithLocation: true,
    meta: {
      fields: ['id', 'name', 'title', 'description', 'advice'],
    },
  });

  const SearchForm = () => (
    <Form layout="inline" {...searchFormProps}>
      <Form.Item label="ID" name="id">
        <Input />
      </Form.Item>
      <Form.Item label="名前" name="name">
        <Input />
      </Form.Item>
      <Form.Item label="タイトル" name="title">
        <Input />
      </Form.Item>
      <Button htmlType="submit" type="primary">
        検索
      </Button>
    </Form>
  );

  return (
    <>
      <List
        resource="experience_actions"
        headerProps={{ title: '行動パターン' }}
        headerButtons={
          <Space>
            <SearchForm />
            <CreateButton onClick={() => createDrawerShow()} />
          </Space>
        }
      >
        <Table
          {...tableProps}
          rowKey="id"
          pagination={{
            ...tableProps.pagination,
            showSizeChanger: true,
            showTotal: (total) => `全${total}件`,
          }}
        >
          <Table.Column dataIndex="name" title="名前" sorter={{ multiple: 1 }} />
          <Table.Column dataIndex="title" title="タイトル" />
          <Table.Column dataIndex="description" title="説明" />
          <Table.Column dataIndex="advice" title="アドバイス" />
          <Table.Column<IExperienceAction>
            dataIndex="actions"
            render={(_, record) => (
              <EditButton onClick={() => editDrawerShow(record.id)} hideText size="small" />
            )}
          />
        </Table>
      </List>

      <Drawer {...createDrawerProps}>
        <Create saveButtonProps={createSaveButtonProps} goBack={false}>
          <Form {...createFormProps} layout="vertical">
            <Form.Item name="name" label="名前(管理用)">
              <Input />
            </Form.Item>
            <Form.Item name="title" label="タイトル">
              <Input />
            </Form.Item>
            <Form.Item name="description" label="説明">
              <Input.TextArea rows={8} />
            </Form.Item>
            <Form.Item name="advice" label="アドバイス">
              <Input.TextArea rows={8} />
            </Form.Item>
          </Form>
        </Create>
      </Drawer>
      <Drawer {...editDrawerProps}>
        <Edit
          recordItemId={id}
          saveButtonProps={editSaveButtonProps}
          isLoading={editFormLoading}
          goBack={false}
          breadcrumb={false}
          headerButtons={[]}
        >
          <Form {...editFormProps} layout="vertical">
            <Form.Item name="name" label="名前(管理用)">
              <Input />
            </Form.Item>
            <Form.Item name="title" label="タイトル">
              <Input />
            </Form.Item>
            <Form.Item name="description" label="説明">
              <Input.TextArea rows={8} />
            </Form.Item>
            <Form.Item name="advice" label="アドバイス">
              <Input.TextArea rows={8} />
            </Form.Item>
          </Form>
        </Edit>
      </Drawer>
    </>
  );
};
